var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7.583a.578.578 0 01-.583.584H1.995l5.998 6.008a.566.566 0 010 .817.552.552 0 01-.41.175.548.548 0 01-.408-.175l-7-7a.564.564 0 010-.817l7-7a.565.565 0 01.818 0 .566.566 0 010 .817L1.995 7h16.422c.326 0 .583.257.583.583z",
    fill: "#fff"
  })));
}

SvgArrowLeft.displayName = 'ArrowLeft';
export default SvgArrowLeft;